export const userManagement = [
  {
    name: 'Home',
    url: '/users/home',
    icon: 'icon-drop'
  },
  {
    title: true,
    name: 'Function'
  },
  {
    name: 'register user',
    url: '/users/create',
    icon: 'icon-note'
  },
  {
    name: 'permission',
    url: '/users/permission',
    icon: 'fa fa-th'
  },
  {
    name: 'History',
    url: '/users/history',
    icon: 'fa fa-history'
  }
];
